import { render } from "./mute-cta-button.vue?vue&type=template&id=4716dbe7"
import script from "./mute-cta-button.vue?vue&type=script&lang=js"
export * from "./mute-cta-button.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__